<style scoped>
#worklists {
	padding: 0px;
	min-height: 100%;
}
</style>

<template>
	<div id="worklists">
		<v-row no-gutters>
			<v-col cols="12" class="toolbar">
				<v-btn color="#00AAFD" @click="new_search()" class="mr-1 text-capitalize white--text">New search</v-btn>
			</v-col>
		</v-row>
		<v-row justify="start" no-gutters class="px-1 white">
			<div @click="include_shared=!include_shared; load_worklists()">
				<v-checkbox 
					class="mx-1"
					color="light-blue"
					:value="include_shared" 
					label="Include task lists shared with me"
					dense hide-details
				/>
			</div>
			<div @click="include_hidden=!include_hidden; load_worklists()">
				<v-checkbox 
					class="mx-1"
					color="light-blue"
					:value="include_hidden" 
					label="Include task lists I've hidden"
					dense hide-details
				/>
			</div>
		</v-row>
		<v-row no-gutters>
			<v-col cols="12">
				<v-alert type="error" v-if="errormsg != ''">{{
					errormsg
				}}</v-alert>

				<div v-if="!loading">
					<worklist_item
						v-for="worklist in worklists"
						v-bind:key="worklist.id"
						:worklist="worklist"
						@click="worklist_id => select_worklist(worklist_id)"
						@delete="worklist => delete_worklist(worklist)"
						@changed_hidden="load_worklists()"
						@changed_pinned="load_worklists()"
						@rename="worklist => rename_worklist(worklist)"
					/>
				</div>

				<div v-if="loading">
					<v-skeleton-loader
						type="list-item-avatar-two-line"
						width="100%"
					></v-skeleton-loader>
					<v-skeleton-loader
						type="list-item-avatar-two-line"
						width="100%"
					></v-skeleton-loader>				
				</div>
			</v-col>
		</v-row>
		<v-del-worklist-dialog
			ref="del_worklist_dialog"
			@deleted="load_worklists()"
		/>
		<v-rename-worklist-dialog
			ref="rename_worklist_dialog"
			@renamed="load_worklists()"
		/>
	</div>
</template>

<script>
import worklist_item from "@/components/worklist/worklist_item"
import del_worklist_dialog from "@/components/worklist/del_worklist_dialog";
import rename_worklist_dialog from "@/components/worklist/rename_worklist_dialog";

import Worklist from "@/models/worklist.js";

export default {
	data() {
		return {
			loading: false,
			errormsg: '',
			worklists: [],
			name_filter: "",
			include_shared: true,
			include_hidden: false
		}
	},
	components: {
		worklist_item,
		'v-del-worklist-dialog': del_worklist_dialog,
		'v-rename-worklist-dialog': rename_worklist_dialog,
	},
	created() {
		// add this page to our breadcrumbs
		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: "Saved Tasklists",
			to: this.$route.path
		});

		this.load_worklists();	
	},
	methods: {
		load_worklists() {
			console.log("reloading")

			this.loading = true;

			let wl = new Worklist();
			wl.list("restful.tasks.lists", this.include_shared, this.include_hidden)
				.then(d => {
					this.worklists = d;
				})
				.catch(message => {
					this.errormsg = message;
				})
				.finally(() => {
					this.loading = false;

					this.$emit('content_changed');
				});	
		},
		new_search() {
			this.$router.push({ name: "Search Tasks"} )
		},
		select_worklist(wlid) {
			this.$router.push({ name: "Tasklist" , params: {id: wlid}})			
		},
		delete_worklist(worklist) {
			this.$refs.del_worklist_dialog.open(worklist);
		},
		rename_worklist(worklist) {
			this.$refs.rename_worklist_dialog.open(worklist);
		}
	},
}
</script>
